export default "__VITE_ASSET__gOJ79r11__"